import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/lightbulb.svg';
import { Icon } from '../Icon/Icon';
export const LightbulbIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
